import gql from "graphql-tag";
const DELETE_NEWSLETTER = gql `
  mutation deleteNewsletter($id: ID!) {
    deleteNewsletter(id: $id) {
      status
    }
  }
`;
export default DELETE_NEWSLETTER;
